import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomListComponent } from './components/custom-list/custom-list.component';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { SuccessPageComponent } from './components/success-page/success-page.component';
import { InfoPageComponent } from './components/info-page/info-page.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListboxModule } from 'primeng/listbox';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { LayoutModule } from '../layout';
import { AmountSliderComponent } from './components/amount-slider';
import { SliderModule } from 'primeng/slider';
import { AmountModule } from './pipes/amount';

@NgModule({
  declarations: [
    PageNotFoundComponent,
    CustomListComponent,
    SuccessPageComponent,
    ErrorDialogComponent,
    InfoPageComponent,
    AmountSliderComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    DynamicDialogModule,
    ListboxModule,
    ButtonModule,
    RippleModule,
    LayoutModule,
    FormsModule,
    SliderModule,
    AmountModule,
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    DynamicDialogModule,
    PageNotFoundComponent,
    CustomListComponent,
    ErrorDialogComponent,
    ButtonModule,
    RippleModule,
    AmountSliderComponent,
    SuccessPageComponent,
  ],
})
export class SharedModule {}
